import React, { useState, useEffect, useRef } from "react";
import "../styles/secdevtool.css";
import CodeMirror from '@uiw/react-codemirror';
import Ajv from "ajv";
import ClipboardJS from "clipboard";

const JsonFormatter = () => {
  const ajv = new Ajv({ allErrors: true });
  const codeMirrorRef = useRef(null);
  const lineNumberRef = useRef(null);
  const [jsonData, setJsonData] = useState("");
  const [validationResult, setValidationResult] = useState({
    valid: null,
    errors: null,
  });
  const [copied, setCopied] = useState(false); // Zustand für den Kopierstatus

  //Format JSON
  const handleFormatClick = () => {
    try {
      if (!jsonData) return; // Do nothing if JSON data is empty
      const formatted = JSON.stringify(JSON.parse(jsonData), null, 4);
      setJsonData(formatted);
      setValidationResult({
        valid: null,
        errors: null,
      });
    } catch (error) {
      setValidationResult({
        valid: false,
        errors: [{ message: "Invalid JSON format" }],
      });
    }
  };

  //Minify JSON
  const handleMinifyClick = () => {
    try {
      if (!jsonData) return; // Do nothing if JSON data is empty
      const minified = JSON.stringify(JSON.parse(jsonData));
      setJsonData(minified);
      // Hier das Validation Result auf null setzen
      setValidationResult({
        valid: null,
        errors: null,
      });
    } catch (error) {
      setValidationResult({
        valid: false,
        errors: [{ message: "Invalid JSON format" }],
      });
    }
  };

  //Reset
  const handleResetClick = () => {
    setJsonData("");
    setValidationResult({
      valid: null,
      errors: null,
    });
  };

  //Copy JSON
  useEffect(() => {
    const currentCodeMirrorRef = codeMirrorRef.current;

    if (currentCodeMirrorRef && lineNumberRef.current) {
      codeMirrorRef.current.addEventListener("scroll", handleScroll);
    }

    // Initialisiere den ClipboardJS
    const clipboard = new ClipboardJS(".btn-copy", {
      text: () => jsonData, // Der zu kopierende Text
    });

    clipboard.on("success", () => {
      setCopied(true); // Aktualisiere den Kopierstatus
      setTimeout(() => setCopied(false), 1500);
    });

    return () => {
      if (currentCodeMirrorRef) {
        currentCodeMirrorRef.editor.removeEventListener("scroll", handleScroll);
      }
      clipboard.destroy(); // Zerstöre das ClipboardJS-Objekt, um Speicherlecks zu vermeiden
      };
      }, [jsonData, codeMirrorRef]); // Füge jsonData als Abhängigkeit hinzu, um die Eventlistener korrekt zu aktualisieren

      const handleValidateClick = () => {
        try {
          const parsedData = JSON.parse(jsonData);
          const valid = ajv.validate(schema, parsedData);

          setValidationResult({
            valid: valid,
            errors: ajv.errors,
          });

          if (valid) {
            console.log("Valid JSON!");
          }
          } catch (error) {
            const errorMessage = error.message;
            let positionInfo = "";

          if (error.at) {
            // If there is a position, try to approximate the line number
            const lines = jsonData.split("\n");
            const position = parseInt(error.at, 10);

            let lineEnd = 0;
            for (let i = 0; i < lines.length; i++) {
              lineEnd += lines[i].length + 1; // +1 for the newline character
              if (lineEnd >= position) {
                positionInfo = `(line ${i + 1})`;
                break;
              }
            }
          }

          setValidationResult({
            valid: false,
            errors: [{ message: errorMessage, position: positionInfo }],
          });
        }
      };

      const schema = {
        additionalProperties: true,
      };

      const handleScroll = () => {
        lineNumberRef.current.scrollTop = codeMirrorRef.current.scrollTop;
      };

  return (
      <main>
        <div className="container mt-4">
          {/* Header Section */}
          <h2>JSON Formatter</h2>

          {/* JSON Input Section */}
          <section aria-labelledby="json-input">
            <h3 id="json-input" className="mt-4">Input</h3>
            <CodeMirror
                ref={codeMirrorRef}
                value={jsonData}
                onChange={(value) => setJsonData(value)}
                placeholder="Enter JSON here"
                height="50vh"
                basicSetup={{
                  foldGutter: false,
                  dropCursor: false,
                  allowMultipleSelections: false,
                  indentOnInput: false,
                }}
            />
          </section>

          {/* Action Buttons */}
          <section aria-labelledby="actions">
            <h3 id="actions" className="mt-4">Actions</h3>
            <button
                type="button"
                className="btn btn-secondary mt-2"
                onClick={handleValidateClick}
            >
              Validate JSON
            </button>
            <button
                type="button"
                className="btn btn-secondary mt-2 ms-1"
                onClick={handleFormatClick}
            >
              Format JSON
            </button>
            <button
                type="button"
                className="btn btn-secondary mt-2 ms-1"
                onClick={handleMinifyClick}
            >
              Minify JSON
            </button>
            <button
                type="button"
                className="btn btn-secondary mt-2 ms-1"
                onClick={handleResetClick}
            >
              Reset
            </button>
            <button
                type="button"
                className="btn btn-secondary mt-2 ms-1 btn-copy"
            >
              Copy JSON
            </button>
            {copied && <div className="text-success mt-2">Text has been copied</div>}
          </section>

          {/* JSON Validation Result */}
          <section aria-labelledby="validation-result">
            <h3 id="validation-result" className="mt-4">Validation Result</h3>
            {validationResult.valid !== null && (
                <div className="mt-2 pb-5">
                  {validationResult.valid ? (
                      <div className="text-success">Valid JSON!</div>
                  ) : (
                      <>
                        <div className="text-danger">Invalid JSON:</div>
                        <ul>
                          {validationResult.errors.map((err, index) => (
                              <li key={index}>{err.message}</li>
                          ))}
                        </ul>
                      </>
                  )}
                </div>
            )}
          </section>
        </div>
      </main>
  );
}

export default JsonFormatter;
